import { FC, Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";
import useRequest from "@shared/hooks/useRequest";
import useScroll from "@shared/hooks/useScroll";
import MegaMenuSidebar from "../megamenu-sidebar";
import IconlyCategoryIcon from "@svg/new-design/bottom-tab-navigation/CategoryIcon";
import homeApi from "@features/home/helpers/homeApi";

const BTNCategoryButton: FC = () => {
  const { blockScroll, allowScroll } = useScroll();

  const { data: megamenu } = useRequest(homeApi.getMegamenu(), {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
  });

  return (
    <Popover className="relative grow w-full flex items-center" as="nav">
      {({ close, open }) => {
        if (!open) allowScroll();
        return (
          <>
            <Transition
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Popover.Overlay className="fixed inset-0 z-50 backdrop-brightness-50" />
            </Transition>
            <Popover.Button
              aria-label="Mobile Toggle Menu"
              className="grow h-full flex flex-col items-center justify-center "
              onClick={blockScroll}
            >
              <IconlyCategoryIcon className="h-5    w-5" />
              <span className="text-xs leading-5 text-center">
                دسته‌بندی‌ها
              </span>
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200 delay-300"
              enterFrom="opacity-0 translate-x-full"
              enterTo="opacity-100 translate-x-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-x-0"
              leaveTo="opacity-0 translate-x-full"
            >
              <Popover.Panel className="fixed top-0 right-0 z-50 h-full min-h-full  w-screen max-w-[257px] transform overflow-y-auto bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                <MegaMenuSidebar
                  megamenu={megamenu}
                  onBack={close}
                  onClose={close}
                />
              </Popover.Panel>
            </Transition>
          </>
        );
      }}
    </Popover>
  );
};

export default BTNCategoryButton;
